import { AnswerFormDocument, AnswerFormMutationVariables } from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useAnswerForm = () => {
  const [answer, loading] = useMutation(AnswerFormDocument, {
    extractorFn: (data) => data.formsMutations.bulkCreateFormsAnswer,
    update(cache, { data }) {
      const membershipId = data?.formsMutations.bulkCreateFormsAnswer.answers
        ? data?.formsMutations.bulkCreateFormsAnswer.answers[0]?.membership?.id
        : undefined
      if (membershipId) {
        cache.modify({
          id: `FormsMembership:${membershipId}`,
          fields: {
            answersConnection(existingAnswerConnection) {
              const existingTotalCount = existingAnswerConnection.totalCount || 0
              return {
                ...existingAnswerConnection,
                totalCount: existingTotalCount + 1,
              }
            },
          },
        })
      }
    },
  })

  return {
    loading,
    answer(variables: AnswerFormMutationVariables) {
      return answer({
        variables,
      })
    },
  }
}
